import { createMemoStyles } from '@wds/utils';
import { MD_MEDIA_QUERY } from '~shared/media-query';
import { PricingAppTheme, PackageTheme } from '~app/styles/pricing/types';
import { Packages } from '~shared/constants/pricing';

type Props = {
  packageName: Packages;
};

type RuleNames = 'PricingPackageContainer' | 'PricingPackage' | 'Highlighted' | 'PlanFeaturesLink';

export const HIGHLIGHT = (defaultColor: string, packageTheme: PackageTheme): object => ({
  border: ({ packageName }: Props) =>
    `1px solid ${packageTheme[packageName] ? packageTheme[packageName].primary : defaultColor}`,
});

export default createMemoStyles<RuleNames, Props, PricingAppTheme>(
  ({ spacing, pricingPalette, packageTheme }: PricingAppTheme) => ({
    PricingPackageContainer: {
      marginBottom: spacing[4],
      width: '100%',

      [MD_MEDIA_QUERY]: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 320,
        marginLeft: spacing[3],
        marginRight: spacing[3],
      },

      [`&.package-${Packages.AdvantageAnnual}`]: {
        gridRow: 1,
      },
    },
    PricingPackage: {
      position: 'relative',
      padding: [spacing[5], 0],
      border: `1px solid ${pricingPalette.colors.flint}`,
      borderRadius: 3,
      marginBottom: spacing[6],

      '& + div': {
        display: 'none',
      },

      [MD_MEDIA_QUERY]: {
        height: '100%',
        transition: 'border-color 0.5s ease',

        '&:hover': {
          ...HIGHLIGHT(pricingPalette.colors.flint, packageTheme),
        },

        '& + div': {
          display: 'inherit',
        },
      },
    },

    Highlighted: {
      [MD_MEDIA_QUERY]: {
        ...HIGHLIGHT(pricingPalette.colors.flint, packageTheme),
        marginTop: -spacing[6],
        paddingTop: 56,
      },
    },

    PlanFeaturesLink: {
      fontSize: 13,
      margin: [spacing[4], spacing[5], 0],
      textAlign: 'center',

      [MD_MEDIA_QUERY]: {
        position: 'absolute',
        bottom: spacing[4],
        textAlign: 'left',
      },
    },
  })
);
